import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

/**
 * Sends the user to /logout when an authenticated request comes back as 401
 * (stale session, revoked token, etc).
 *
 * Lives in its own interceptor so it always fires — independent of whether
 * the caller suppressed the toast via IGNORE_META_MESSAGE. The login endpoint
 * is excluded because the form owns its own 401 messaging.
 */
@Injectable()
export class UnauthorizedRedirectInterceptor implements HttpInterceptor {
  private router = inject(Router);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap({
        error: (error) => {
          if (error instanceof HttpErrorResponse && error.status === 401 && request.url !== '/api/auth/login') {
            this.router.navigateByUrl('/logout');
          }
        },
      }),
    );
  }
}
